import { render, staticRenderFns } from "./PhCube.vue?vue&type=template&id=16e74b43"
import script from "./PhCube.vue?vue&type=script&lang=js"
export * from "./PhCube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports